    <template>
         <Scroll :on-reach-bottom="handleReachBottom" height="700" min-height="700" max-height="1500" :distance-to-edge=[0,10]>
    <div class="kucun">
         <div class="topBar">
                    <div class="daohang">
                            <span @click="tiaozhuan" style="cursor: pointer; font-size:20px;color:#2d8cf0;font-family:'微软雅黑' ">
                            <Icon type="ios-home"></Icon>{{language.shouye}}</span>>
                            <span style="cursor: pointer; font-size:20px;font-family:'微软雅黑'">{{language.xiaoshoutidanchakan}}</span>
                        </div>
            <div class="iptc">
                <div class="iptlis">
                                <Icon type="ios-search" class='ico'></Icon>

                    <input  class="iptli" :placeholder=language.chaxunqingdianjiwo type="primary" @click="showserch">
                    <div class="numEve">
                      <div class="numlitter">{{language.gong}}{{numnum}}{{language.tiao}}</div></div>
                </div>
            </div>
        </div>
        <modal class="serchlist"  v-model="modal1"
         width="86%" :styles="{top: '60px',left:'100px'}">
            <div class="pz">
                <Input type="text" v-model="numpinzhong" clearable style="width: 200px"></Input>
                <span class='pinzhongs'>{{language.danjuhao}}</span>
            </div>
            <div class="hou">
                <span class='hous'>{{language.zhuangtai}}</span>
                <Select :placeholder=language.qingxuanze name="" id="" clearable style="width: 200px" v-model="numhou">
                    <Option v-for="item in cityList3" :value="item.value" :key="item.value">{{item.label}}</Option>
                    <!-- <Option label="作废" value="00">{{language.zuofei}}</Option>
                    <Option label="录入" value="10">{{language.luru}}</Option>
                    <Option label="审批通过" value="30">{{language.shenpitongguo}}</Option>
                    <Option label="待审批" value="20-01">{{language.daishenpi}}</Option>
                    <Option label="审批退回" value="40-01">{{language.shenpituihui}}</Option>
                    <Option label="部分发货" value="50-01">{{language.bufenfahuo}}</Option>
                    <Option label="全部发货" value="60-01">{{language.quanbufahuo}}</Option>
                    <Option label="提单结算完成" value="90-01">{{language.tidanjiesuanwancheng}}</Option>
                    <Option label="提交" value="20-02">{{language.tijiao}}</Option>
                    <Option label="出库申请结算完成" value="40-02">{{language.chukushenqingjiesuanwancheng}}</Option>
                    <Option label="部分结算" value="50-02">{{language.bufenjiesuan}}</Option> -->
                </Select>
            </div>
            <div class="leixing">
                <Select :placeholder=language.qingxuanze name="" id=""  class='leixings' clearable style="width: 200px" v-model="nummujuanhao">
                     <Option v-for="item in cityList2" :value="item.value" :key="item.value">{{item.label}}</Option>
                    <!-- <Option lable="提单" value="01">{{language.tidan}}</Option>
                    <Option lable="出库申请" value="02">{{language.chukushenqing}}</Option> -->
                </Select><span class='housw' >{{language.danjuleixing}}</span>
            </div>
            <div class="ph">
                <Input type="text" v-model="numpaihao" clearable style="width: 200px"></Input>

                <span class='paihaos'>{{language.picihao}}</span>
            </div>
        <div class="kuan">
            <DatePicker type="daterange" v-model="paramssubData" placeholder="Select date" style="width: 200px" class="qishi" @on-change="getDateTime"></DatePicker>
            <span class="sqrq">{{language.shenqingriqi}}</span>
        </div>
        

            <div class="zhuangtai">
                <Select :placeholder=language.qingxuanze name="" id=""  class='houzt' v-model="numkunbaohao" clearable style="width: 200px">
                    <Option v-for="item in cityList2" :value="item.value" :key="item.value">{{item.label}}</Option>

                   <!--  <Option lable="未出库" value="10">{{language.weichuku}}</Option>
                    <Option lable="部分出库" value="20">{{language.bufenchuku}}</Option>
                    <Option lable="已出库" value="30">{{language.yichuku}}</Option> -->
                </Select><span class='hous'>{{language.chukuzhuangtai}}</span>
            </div>
        <div class="fahuo">
            <DatePicker type="daterange" v-model="paramssubDatas" placeholder="Select date" style="width: 200px" class="qishi" @on-change="getDateTime2"></DatePicker>
            <span class="sqrq">{{language.fahuoqishiriqi}}</span>
        </div>
        <div class="ph">
                <Input type="text" v-model="cpyl" clearable style="width: 200px"></Input>

                <span class='paihaos'>{{language.mujuanhao}}</span>
        </div>
        <div class="ph">
                <Input type="text" v-model="kunbao" clearable style="width: 200px"></Input>

                <span class='paihaos'>{{language.kunbaohao}}</span>
        </div>
  <!--           <div class="chanpinyuanliao">
                <Select :placeholder=language.qingxuanze name="" id="" v-model="cpyl" clearable style="width: 200px">
                    <Option label="原料" value="MATERIAL">原料</Option>
                    <Option label="仓储" value="PRODUCT">成品</Option>
                </Select>
                <span class='cunhuo'>存货性质</span>
            </div>   --> 
        <div slot="footer" style="background-color:rgb(249,249,249);">
            <div class="chaxun" @click='chaxun()'>{{language.chaxun}}</div>
            <div class="chongzhi" @click='chongzhis()'>{{language.chongzhi}}</div>
        </div>
         </modal>



    <Table border :columns="columns1" :data="data1" class="border"></Table> 
    <Col class="demo-spin-col" span="24" v-show="jiazai">
                    <Spin fix>
                        <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
                        <div>Loading</div>
                    </Spin>
                </Col>
         <div class="add_more_data">
 <!--           <p class="add_more_data_btn" v-show="moredata">
              {{language.jiazaigengduo}}
            </p> -->
            <p class="add_more_data_btn" v-show="!moredata">
              {{language.jiazaiwanbi}}
            </p>
        </div>

<!--     <div class="add_more_down_load">
        <p class="add_more_all_weight">合计： <span class="add_more_all_weight_span">{{resl}}</span>kg</p>
        
    </div> -->
        <div class="bootBanner">
            <p class="liang">
                <!-- <span class="button_plan" @click="addTitles">
                    <span  style="margin-right:50px;"><Icon type="ios-compose"></Icon>提货</span>
                </span> -->
                       <span class="add_more_all_weight">{{language.heji}}： <div class="add_more_all_weight_span">{{resl}}</div>kg</span>
<!--         <span class="add_more_add_more_down_load_btn" @click="downLoadData">

                <Icon type="archive" class="down"></Icon>
        {{language.shujuxiazai}}
        </span> -->

            </p>
    </div>
    </div>
</Scroll>
</template>
<style scoped>
    .ivu-spin-fix .ivu-spin-main{
        background-color:#f5f7f9 !important;

    }
    .demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }
    .demo-spin-col{
        height: 100px;
        position: relative;
        background-color:#f5f7f9 !important;
        margin:0 auto;

        /*border: 1px solid #eee;*/
    }
    .kucun{
    margin-bottom: 90px;
    }
    .bootBanner{
    overflow:hidden;
    min-width:100%;
    margin-top:50px;
    position: fixed;
    bottom:-5px;
    margin-top:30px;
    z-index: 10;
    /*height: 70px;*/
    overflow:hidden;
    margin-top:300px;
    }
    .bootBanner span span{
    float: right;
    width:120px;
    height:70px;
    line-height: 70px;
    border: 1px solid #ccc;
    text-align:center;
    background-color:#1d92be;
    cursor:pointer;
    font-size: 18px;
    margin-right: 5px;
    display: block;
    }
    /*.boo*/
    .bootBanner .ivu-icon{
    margin-right:5px;
    color: #ffffff;
    font-size: 20px;
    }
    .bootBanner .liang{
    background-color:#e5ebf2;
    display: block;
    /*width: %;*/
    height: 100px;
    margin-right:150px;
    /*margin-top:30px;*/
    /*position: fixed;*/
    /*bottom: -10px;*/
    /*margin-right: 20px;*/

    }
    .serchlist input{
    width:200px;
    height: 30px;
    /*margin-top:30px;*/
    border:1px solid #dddddd;
    text-align: center;
    border-radius: 3px;
    }
    .serchlist .pz span{
    position: absolute;
    left: 10px;
    top:-15px;
    }
    .serchlist .chanpinyuanliao span{
    position: absolute;
    left: 10px;
    top:-15px;
    }
    .serchlist .pz,.ph,.hou,.kuan,.zhuangtai,.leixing,.qishi,.zhongzhi,.chanpinyuanliao,.fahuo{
    position: relative;
    /*float: left;*/
    margin-left: 100px;
    margin-top: 20px;
    display: inline-block;
    /*border-radius:5px;*/
    }
    .serchlist .ph span{
    width:80px;
    position: absolute;
    left: 10px;
    top:-15px;
    }
    .serchlist .hou span{
    width:50px;
    position: absolute;
    left: 10px;
    top:-15px;
    z-index: 2;
    }
    .serchlist .leixing span{
    width:50px;
    position: absolute;
    left: 10px;
    top:-15px;
    }


    .serchlist .zhuangtai span{
    position: absolute;
    width: 70px;
    left: 10px;
    top:-15px;
    }
    .serchlist .kuan span{
    position: absolute;
    left: 120px;
    top:5px;
    }
    .serchlist .fahuo span{
    position: absolute;
    width: 80px;
    left: 120px;
    top:5px;
    }

    .chaxun,.chongzhi{
    width:120px;
    height: 40px;
    background-color:#1d92be;
    border-radius: 10px;
    text-align: center;
    line-height: 40px;
    color: #f5f5f5;
    /*margin-top: 40px;*/
    display: inline-block;
    margin-right: 350px;
    }
    .serchlist select{
    width:200px;
    height: 30px;
    border-radius: 5px;
    border:1px solid #dddddd;
    }
    .serchlist .kuan{
    margin-left: 0px;
    }
    .serchlist .fahuo{
    margin-left: 0px;
    }
    .numlitter{
    margin-right: 20px;
    }
    .iptlis{
    position: relative;
    }
    .iptlis .ico{
    position: absolute;
    right: 288px;
    top:25px;
    z-index: 11111; 
    }
    .kucun .daohang{
    margin-left: 20px;
    margin-top:10px;
    }

    .tablemainadd{
    border-top:1px solid black;
    border-bottom:1px solid black;
    overflow:hidden;
    }
    .tablemainadd .tablemainadds{
    border-right: 1px solid black;
    width:50%;
    height: 40px;
    line-height: 40px;
    text-align:center;
    float: left;
    }
    .serchlist span{
    width:50px;
    height: 20px;
    line-height: 30px;
    display: inline-block;
    text-align: center;
    background-color: white;
    }




    .tabletitle{
    height: 30px;
    line-height: 40px;
    text-align:center;
    font-weight: bold
    }
    .tablecontantBot{
    overflow: hidden;
    }
    .tablecontantBot .titcon{
    width:25%;
    display: inline-block;
    height: 30px;
    text-align: center;
    line-height: 30px;
    /*height: 100%;*/
    float:left;
    border-right: 1px solid black;
    border-top:1px solid black;
    }


    .numEve{
    position: absolute;
    right: 61px;
    top:10px;
    line-height: 30px;
    background-color:#ffffff;
    height: 30px;
    width: 250px;
    text-align: right;
    color: #0066ff;
    }
    .topBar{
    position: relative;
    }
    .daohang{
    position: absolute;
    top:10px;
    left: 10px;
    z-index: 10;
    }
    .down{
    width:30px;
    height:30px;
    position:absolute;
    top:15px;
    right:40px;
    font-size: 45px;
    /*background-color:#fff;*/
    }


    .iptli{
    width:140px;
    border:none;
    height: 24px; 
    position: absolute;
    right: 168px;
    top:20px;
    cursor: pointer;
    background-color: #eaeaea;
    padding-left:30px;
    /*box-shadow: 3px 6px 6px 2px #E6E3F5;*/
    /*text-align:left;*/
    border-radius: 3px;
    z-index: 10;
    /*border-shadow:3px 6px;*/
    /*position: relative;*/
    }

    .iptc{
    height: 65px;
    /*        border-bottom: 1px solid #dddddd;
    border-top: 1px solid #dddddd;*/
    position: relative;
    background:url(../assets/header.gif)repeat-x 0 0px;
    background-color: #cdd9e8;
    /*border-color: #8ba0bc;*/
    }

    .numEve{
    margin-top:6px;
    }


    .ivu-table-wrapper{
    border:none;
    }
    .classtit{
    height: 30px;
    /*line-height: 30px;*/
    /*border-bottom: 1px solid #2d8cf0;*/
    }
    .classtit div{
    color:#2d8cf0;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-bottom:2px solid #2d8cf0;
    width:100px;
    } 
    .add_more_down_load{
    width:100%;
    height:100px;
    position: relative;
    bottom: 0;
    background-color:#e5ebf2;
    }
    .add_more_all_weight{
    width:250px;
    height:80px;
    line-height:80px;
    position: absolute;
    top: 5px;
    left:5px;
    text-align:center;
    background-color:#e5ebf2;
    }
    .add_more_all_weight_span{
    color:red;
    display: inline-block;
    }
    .add_more_add_more_down_load_btn{
    width:120px;
    height:100px;
    line-height:120px;
    position: absolute;
    top: 5px;
    right:220px;
    text-align:center;
    cursor:pointer;
    background-color:#1d92be;
    color:#fff;
    }
    .add_more_add_more_down_load_btn_span{
    width:30px;
    height:30px;
    position:absolute;
    top:10px;
    right:35px;
    background-color:#fff;
    }
    .add_more_data{
    width:100%;
    height:60px;
    position: relative;
    }
    .add_more_data_btn{
    /*width:110px;*/
    height:40px;
    line-height:40px;
    position: absolute;
    top: 5px;
    left:50%;
    transform: translateX(-50%);
    text-align:center;
    cursor:pointer;
    }
    .add_more_data_btn:hover{
    color:#2d8cf0;
    }
    .jia{
    text-align: center; 
    cursor: pointer;
    }
    .box{
    /*width:239px;*/
    height: 83px;
    background-color:rgba(204,204,204,1);
    border: 1px solid black;
    }
    .ivu-table-wrapper{
    width: 100%;
    }

    .ivu-tabs{
    width:100%;
    }

    .ivu-table td{
    border: 1px solid #e9eaec;
    }
    .ivu-table th{
    text-align: center;
    }
    .ivu-table-overflowX{
    overflow: auto;
    }
    .ivu-table-row td:nth-child(1){
    background:red;     
    /*    position: relative;*/
    }
    .ivu-table-row :nth-child(2){
    /*width:219px;     */   
    /*display: inline-block;*/
    background-color: red;
    /* position: absolute;
    left: 100px;*/
    /*border: none;*/
    padding: 0;
    }
</style>
<script>
    // var fis=document.getElementsByClassName('ivu-table-tbody  ivu-table-row');
    
    import {mapGetters,mapActions} from 'vuex';
    import axios from 'axios';
    import ladingexpand from './ladingexpand.vue';
    import config from 'config/apiConfig';
    import language from 'api/language'
    export default {
        data () {
            return {
                language:{},
                jiazai:false,
                totalPageCount:'',
                numpinzhong:'',
                numpaihao:'',
                numhou:'',
                // numchang:'',
                numcangku:'',
                numkunbaohao:'',
                cpyl:'',
                kunbao:'',
                nummujuanhao:'',
                numnum:'',
                orderNum:'',
                packNumK:'',
                prodCode:'',
                raval:false ,
                modal1:false,
                falg:0,
                newArr:[],
                paramssubData:[],
                paramssubDatas:[],
                flag:0,
                paramsData:"",
                moredata:true,
                cityList2: [
                    {
                        value: '10',
                        label:language.weichuku,
                    },
                    {
                        value: '20',
                        label: language.bufenchuku,
                    },
                    {
                        value: '30',
                        label: language.yichuku,
                    },
                    ],
                cityList1: [
                    {
                        value: '10',
                        label:language.weichuku,
                    },
                    {
                        value: '02',
                        label: language.chukushenqing,
                    },
                    ],
                cityList3: [
                    {
                        value: '00',
                        label:language.zuofei,
                    },
                    {
                        value: '10',
                        label:language.weichuku,
                    },
                    {
                        value: '30',
                        label: language.yichuku,
                    },
                    {
                        value: '20-01',
                        label: language.daishenpi,
                    },
                    {
                        value: '40-01',
                        label: language.shenpituihui,
                    },
                    {
                        value: '50-01',
                        label: language.bufenfahuo,
                    },
                    {
                        value: '60-01',
                        label: language.quanbufahuo,
                    },
                    {
                        value: '90-01',
                        label: language.tidanjiesuanwancheng,
                    },
                    {
                        value: '20-02',
                        label: language.tijiao,
                    },
                    {
                        value: '40-02',
                        label: language.chukushenqingjiesuanwancheng,
                    },
                    {
                        value: '50-02',
                        label: language.bufenjiesuan,
                    },
                    ],
                columns1: [
                    {   
                        title:'',
                        type: 'expand',
                        width: 50,
                        render: (h, params) => {
                            return h('div', {},[
                                h(ladingexpand, {
                                    props: {
                                        rows3: params.row
                                    },
                                })
                            ])
                        }
                    },
                    {
                        title: language.tidanhao,
                        align:"center",
                        key: 'orderNo',
                    },
                    {
                        title: language.laiyuan,
                        align:"center",
                        key: 'singleSourceName'
                    },
                    {
                        title: language.picihao,
                        align:"center",
                        width:130,
                        key: 'batchNum'
                    },
                    {
                        title: language.shenqingriqi,
                        align:"center",
                        width:100,
                        key: 'applyTime'
                    },
                    {
                        title: language.zhuangtai,
                        align:"center",
                        key: 'statusName'
                    },
                    {
                        title: language.chukuzhuangtai,

                        align:"center",
                        key: 'outStatusName'
                    },
                    {
                        title: language.fahuodidian,
                        align:"center",
                        key: 'deliveryLocations'
                    },
                    {
                        title: language.fahuoqishiriqi,
                        width:100,
                        align:"center",
                        key: 'beginShippingTime'
                    },
                    {
                        title: language.fahuozhongliang,
                        align:"center",
                        key: 'quantity'
                    },
                    {align:"center",
                        title: language.fahuoshuliang,
                        key: 'primayQty'
                    },
                   
                ],
              
                data1:[],
                resl:'',
            }
        },
        components: { ladingexpand },
        methods:{
            tidan(){
                let that = this;
                // let params={}
                that.nummujuanhao="01"
                // that.nummujuanhao="提单"
                // that.paramsData=that.nummujuanhao
                // params.falg=that.nummujuanhao
                // that.nummujuanhao.value="01"
                // that.nummujuanhao.lable="提单"
            },
            handleReachBottom(){
                return new Promise(ig => {
                    setTimeout(() => {
                            let that=this;
                // console.log(indexs)
                let paramsData={
                    "limit":'10',
                    "offset":that.data1.length,
                    "orderNo" :that.numpinzhong,
                    "batchNum" :that.numpaihao,
                    "status" :that.numhou,
                    "flag": "01",
                    // length :that.numchang,
                    // "applyTime" :that.paramssubData,
                    // warehouseName :that.numcangku,
                    "outStatus" :that.numkunbaohao,
                    "reelNo" :that.cpyl,
                    "serialCode" :that.kunbao,
                    // "flag":that.nummujuanhao,
                    "applyTime1" : that.paramssubData[0],
                    "applyTime2" : that.paramssubData[1],
                    "beginShippingTime" : that.paramssubDatas[0],
                    "endShippingTime" : that.paramssubDatas[1],

                    }
                   console.log(that.data1.length)
                if(that.data1.length%10 != 0){ that.moredata=false;that.jiazai=false; return;}
                if(that.totalPageCount%10 == 0 && that.data1.length == that.totalPageCount){ that.moredata=false;that.jiazai=false; return;}
                        that.jiazai=true;

                axios.post(config.queryXSOntOutApplyHead,paramsData).then(
                    function(response){  
                        ig();
                        
                        if(response.data.resultCode == 1){
                            that.jiazai=false;
                            that.data1 = that.data1.concat(response.data.resultData);
                            that.resl=response.data.page.totalWeight
                            that.$Message.info(language.jiazaigengduo)
                        }else{
                            that.$Message.info(response.data.fsuffix)
                        }

                    })
                return
            // }
                        // const last = this.list1[this.list1.length - 1];
                        // for (let i = 1; i < 11; i++) {
                        //     this.list1.push(last + i);
                        // }
                    }, 500);
                });
            },


             chongzhis(){
                let that = this;
                // console.log(that.numpinzhong)
                that.numpinzhong="";
                that.numpaihao="";
                that.numhou="";
                // that.numchang="";
                that.paramssubData="";
                that.paramssubDatas="";
                that.numcangku="";
                that.numkunbaohao="";
                that.kunbao="";
                that.cpyl="";

                that.mujuanhaos="";
                that.nummujuanhao="";

                // if(that.chongzhi==true){
                //     params.value=""
                // }
            },
        showserch(value){
            let that = this
            // console.log(that.changeNewData)
            // if(that.modal1==false){
            that.modal1=true
            let date=new Date();
            let year=date.getFullYear();
            let month=date.getMonth()+1;
            let moRenDate = year+'-'+month+'-01';
            let allDays = new Date(year,month,0).getDate();
            let arrmoRenDate = year+'-'+month+'-'+allDays;
            let newArr = []
            newArr.push(moRenDate,arrmoRenDate);
            if(that.flag==0){
                that.paramssubData=that.newArr;
                that.paramssubDatas=that.newArr;
            }
        },
             tiaozhuan(){
                this.$router.push({name: 'firstpage',params:{ id:'1'}});
            },
            srechEve(){
                // alert("aaa")
                let that = this;
                if(that.raval==false){
                    that.raval=true
                }else{
                    that.raval=false
                }

            },
            chaxun(){

                // alert(111)
                let that = this;
                that.$Message.info(language.qingshaodeng)
                let params={};
                params.orderNo = that.numpinzhong;
                params.batchNum = that.numpaihao;
                params.status = that.numhou;
                // params.length = that.numchang;
                params.applyTime1 = that.paramssubData[0];
                params.applyTime2 =  that.paramssubData[1];                
                params.beginShippingTime =  that.paramssubDatas[0];                
                params.endShippingTime =  that.paramssubDatas[1];                
                // params.warehouseName = that.numcangku;
                params.outStatus = that.numkunbaohao;
                params.serialCode = that.kunbao;
                params.reelNo = that.cpyl;
                params.flag= that.nummujuanhao;
                // if(that.paramssubData==''){
                //     that.$Message.info('请选择交货期')
                //     }else{
                that.paramsflag=params.flag
                        // that.$Message.info('请稍等')
                axios.post(config.queryXSOntOutApplyHead,params).then(function(response){
                    // console.log(response)
                    if(response.data.resultCode==1){
                        that.numnum=response.data.page.totalPageCount
                        console.log(response)
                            that.resl=response.data.page.totalWeight
                        
                        that.data1=response.data.resultData
                        that.$Message.info(language.sousuochenggong)
                    // console.log(that.numbewdata)
                    // alert(111)
                    that.modal1=false
                    }
                    // console.log(that.row.gcresourceCode)

                })
            // }

            },









           add(response){
                    let that=this
                    let weight=""
                    for (var i = 0 ; i < that.index.processQuerySubBeanLists.length; i++) {
                        console.log(add)
                        if(that.processQuerySubBeanLists.value==null){
                            this.weight.value='0'
                            console.log(that.weight.length)
                        }
                    }
           },











            // show (index) {
            //     this.$Modal.info({
            //         title: 'User Info',
            //         content: `Name：${this.data6[index].name}<br>Age：${this.data6[index].age}<br>Address：${this.data6[index].address}`
            //     })
            // },
            //aaa:function(){
                   // $   ("ivu-table-row td:nth-child(0)").css('background','red')
                //},
            // remove (index) {
            //     this.data6.splice(index, 1);
            // },
           downLoadData(){
            let that = this
                let paramsData = {
                    "offset":that.data1.length,
                    "orderNo" :that.numpinzhong,
                    "batchNum" :that.numpaihao,
                    "status" :that.numhou,
                    // "flag": "01",
                    // length :that.numchang,
                    // "applyTime" :that.paramssubData,
                    // warehouseName :that.numcangku,
                    "outStatus" :that.numkunbaohao,
                    "reelNo" :that.cpyl,
                    "serialCode" :that.kunbao,





                    // "orderNo": "SN028313",
                    "flag": "01",
                    "lang":"zh_CN",
                    "applyTime1" : that.paramssubData[0],
                    "applyTime2" : that.paramssubData[1],
                    "beginShippingTime" : that.paramssubDatas[0],
                    "endShippingTime" : that.paramssubDatas[1],
                }
                this.$Message.success({
                    content: language.qingshaodeng,
                    duration: 2,
                    closable: true
                })
                axios({ 
                  method: 'post',
                  url: config.outStockExpt, 
                  data: paramsData, 
                  responseType: 'blob'
                }).then(function(response){
                    const content = response.data
                    const blob = new Blob([content])
                    const fileName = 'download.xls'
                    if ('download' in document.createElement('a')) { // 非IE下载
                      const elink = document.createElement('a')
                      elink.download = fileName
                      elink.style.display = 'none'
                      elink.href = URL.createObjectURL(blob)
                      document.body.appendChild(elink)
                      elink.click()
                      URL.revokeObjectURL(elink.href) // 释放URL 对象
                      document.body.removeChild(elink)
                    } else { // IE10+下载
                      navigator.msSaveBlob(blob, fileName)
                    }

                })
                  .catch(function (error) {
                    console.log(error)
                  });
            },
            showPanel(){
                this.panlshow=true;
            },
            getDateTime(value){
                // console.log(value);
            let that = this;
                that.flag=1;
                // if(that.flag==0){
                
             that.paramssubData=value;
            },
            getDateTime2(value){
                // console.log(value);
            let that = this;
                // that.flag=1;
                // if(that.flag==0){
                that.flag=1;
             that.paramssubDatas=value;
            },
            // ig(indexs){
            //     let that=this;
            //     // console.log(indexs)
            //     let paramsData={
            //         "limit":'10',
            //         "offset":that.data1.length,
            //         "orderNo" :that.numpinzhong,
            //         "batchNum" :that.numpaihao,
            //         "status" :that.numhou,
            //         "flag": "01",
            //         // length :that.numchang,
            //         // "applyTime" :that.paramssubData,
            //         // warehouseName :that.numcangku,
            //         "outStatus" :that.numkunbaohao,
            //         "stockType" :that.cpyl,
            //         "flag":that.nummujuanhao,
            //         "applyTime1" : that.paramssubData[0],
            //         "applyTime2" : that.paramssubData[1],
            //         }
            //        console.log(that.data1.length)
            //     if(that.data1.length%10 != 0){ that.moredata=false; return;}
            //     if(that.totalPageCount%10 == 0 && that.data1.length == that.totalPageCount){ that.moredata=false; return;}
            //     axios.post(config.queryXSOntOutApplyHead,paramsData).then(
            //         function(response){  
            //             if(response.data.resultCode == 1){
            //                 that.data1 = that.data1.concat(response.data.resultData);
            //                 that.resl=response.data.page.totalWeight
            //                 that.$Message.info('加载更多')
            //             }else{
            //                 that.$Message.info(response.data.fsuffix)
            //             }

            //         })
            //     return
            // },
            addnum(){
            let that=this;
            that.resl=0;
            that.language=language
                axios.post(config.queryXSOntOutApplyHead,{
                "flag": "01",
                }).then(
                    function(response){
                    that.data1=response.data.resultData;
                    console.log(response)
                    that.totalPageCount= response.data.totalPageCount;
                        if(response.data.resultCode=="1"){
                            that.resl=response.data.page.totalWeight
                        }
                    })
            },
            },

        mounted(){
           // this.ig()
           this.addnum()
           this.tidan()
        }
    }

</script>


// WEBPACK FOOTER //
// lading.vue?d3a8f096